import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home'; // Original content of the root page, now used for About
import GameList from './GameList'; // The new root page
import Rodman from './Rodman';
import RodmanEnhanced from './RodmanEnhanced';
import RodmanTest from './RodmanTest'; // Enhanced Rodman with animations
import RodmanAnimationDemo from './components/RodmanAnimationDemo'; // Animation demo
import EventDetails from './EventDetails'; // Event details page
import PlayerLogs from './PlayerLogs'; // Player game logs (dev feature)
import Standings from './Standings'; // Multi-league Standings with FiveThirtyEight style

import Header from './Header';
import './App.css';
import ReactGA from 'react-ga';

ReactGA.initialize('G-ELYCEFYTSR');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
    return (
        <Router>
            <div className="App">
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<GameList />} /> {/* Games is now the root page */}
                        <Route path="/about" element={<Home />} /> {/* Home used for About */}
                        <Route path="/rodman" element={<Rodman />} />
                        <Route path="/rodman-enhanced" element={<RodmanEnhanced />} /> {/* Enhanced Rodman with animations */}
                        <Route path="/rodman-test" element={<RodmanTest />} /> {/* Rodman Test Lab */}
                        <Route path="/rodman-demo" element={<RodmanAnimationDemo />} /> {/* Animation showcase */}
                        <Route path="/event/:id" element={<EventDetails />} /> {/* Event Details route */}
                        <Route path="/dev/player-logs" element={<PlayerLogs />} /> {/* Player Game Logs (dev feature) */}
                        <Route path="/dev/player-logs/:playerId" element={<PlayerLogs />} /> {/* Player Game Logs with player ID */}

                                <Route path="/nba-standings" element={<Standings />} /> {/* Multi-league Standings with FiveThirtyEight style */}
        <Route path="/standings" element={<Standings />} /> {/* Unified Standings */}
                        {/* Deprecated players route removed */}
                    </Routes>
                </main>
            </div>
        </Router>
    );
}

export default App;
